import React, {useState, useEffect, memo} from 'react';
import {createPortal} from 'react-dom';
import {motion, AnimatePresence} from 'motion/react';
import {r} from "@/utils/responsive";
import ButtonReforge from "@/components/ButtonReforge";
import ButtonSpan from "@/components/ButtonSpan";
import ShortcutReforge from "@/components/ShortcutReforge";
import {useNav} from "@/hooks/useNav";
import {progressActions} from "@/stores/progressStore";

interface ExitModalConfirmProps {
    isOpen?: boolean;
    onClose?: () => void;
    onConfirm?: () => void;
}

const ExitModalConfirm: React.FC<ExitModalConfirmProps> = ({
                                                               isOpen = false,
                                                               onClose,
                                                               onConfirm
                                                           }) => {
    const {navigateToSection} = useNav();

    const handleClose = () => {
        onClose?.();
    };

    return createPortal(
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{duration: 0.3}}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        background: `#000E33E5`,
                        zIndex: 9999999,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                    onClick={handleClose}
                >
                    <motion.div
                        initial={{translateY: 40, opacity: 0}}
                        animate={{translateY: 0, opacity: 1}}
                        exit={{translateY: 40, opacity: 0}}
                        transition={{duration: 0.3, ease: "easeOut"}}
                        style={{
                            position: 'relative',
                            width: r.vmax(863),
                            height: r.vmax(604),
                            borderRadius: r.vmax(60),
                            background: `#272E64`,
                            paddingTop: r.vmax(96),
                            paddingBottom: r.vmax(96),
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <p style={{
                            fontSize: r.vmax(48),
                            lineHeight: r.vmax(56),
                            color: `white`,
                            textAlign: 'center',
                            whiteSpace: 'pre-wrap',
                        }}>{`Выйти из игры? \nПрогресс не сохранится`}</p>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: r.vmax(16),
                            width: r.vmax(568)
                        }}>
                            <ButtonReforge height={110} minHeight={110} onClick={handleClose}>
                                <ButtonSpan>{`Нет, вернуться`}</ButtonSpan>
                                <ShortcutReforge>ESC</ShortcutReforge>
                            </ButtonReforge>
                            <ButtonReforge enableGlowEffect={false} height={110} minHeight={110}
                                           onClick={() => handleClose?.()}
                                           style={{
                                               background: '#5A5A5A10',
                                               boxShadow: 'inset 0px -26px 34px rgba(255, 255, 255, 0.16), inset 0px 5px 50px rgba(255, 255, 255, 0.2)'
                                           }}>
                                <ButtonSpan>{`Да, выйти`}</ButtonSpan>
                                <ShortcutReforge isLarge shadowColor="#9CB7FF">ENTER</ShortcutReforge>
                            </ButtonReforge>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>,
        document.body
    );
};

export default memo(ExitModalConfirm);
